import React, { Component } from "react";
import { connect } from "react-redux";

import { selectRole, selectSearchWord } from "Actions";
import _ from "i18n";

export class FilterBar extends Component {
  componentDidMount() {
    window.addEventListener("click", this.closeRolesList);
  }

  componentWillUnmount() {
    window.removeEventListener("click", this.closeRolesList);
  }

  closeRolesList(e) {
    const rolesList = document.getElementsByClassName("role-list").item(0);
    if (
      rolesList &&
      !rolesList.contains(e.target) &&
      rolesList.style.display === "block" &&
      e.target.id !== "role-list-display"
    ) {
      $(".role-list").slideUp(500);
    }
  }

  handleClick(e) {
    $(".role-list").slideUp(300);

    const selected = document.getElementsByClassName("role-selected").item(0);
    selected.textContent = e.target.textContent;
    this.props.dispatch(selectRole(e.target.id));
  }

  setSearchWord(e) {
    const { dispatch } = this.props;
    let word = e.target.value;
    if (word && word.length >= 3) {
      dispatch(selectSearchWord(word));
    } else {
      dispatch(selectSearchWord(""));
    }
  }

  toggleRolesList() {
    $(".role-list").slideToggle(500);
  }

  render() {
    const { auth } = this.props;

    let isLR = false;

    if (
      auth &&
      auth.navCommunity &&
      auth.user &&
      auth.user.roles &&
      auth.user.roles.length > 0
    ) {
      const currentRole = auth.user.roles.find(
        r => r.organization && r.organization.id === auth.navCommunity.id
      );
      if (currentRole && currentRole.type === "LEGAL_REPRESENTATIVE") {
        isLR = true;
      }
    }

    return (
      <div className="filter-bar small-8 grid-x">
        <div className="column small-8 filter-bar__search">
          <input
            type="text"
            placeholder={_("Search by name...")}
            title="Search text"
            onChange={e => this.setSearchWord(e)}
            spellCheck="false"
            autoCorrect="off"
          />
        </div>
        <div className="column small-4 filter-bar__roles">
          <span className="role-selected">{_("ALL")}</span>
          <i
            className="icotam-filter"
            id="role-list-display"
            onClick={this.toggleRolesList.bind(this)}
          />
          <div className="role-list">
            <ul>
              <li
                id="ALL"
                onClick={this.handleClick.bind(this)}
                className="block-role all"
              >
                {_("ALL")}
              </li>
              {isLR && (
                <li className="block-role">
                  <ul>
                    <li id="0ACTIVE" onClick={this.handleClick.bind(this)}>
                      {_("Active")}
                    </li>
                    <li id="0NOT_ACTIVE" onClick={this.handleClick.bind(this)}>
                      {_("Not active")}
                    </li>
                  </ul>
                </li>
              )}
              <li className="block-role">
                <h5>{_("Blog roles")}</h5>
                <ul>
                  <li id="2AUTHOR" onClick={this.handleClick.bind(this)}>
                    {_("Author")}
                  </li>
                  <li id="2REDACTOR" onClick={this.handleClick.bind(this)}>
                    {_("Redactor")}
                  </li>
                  <li
                    id="2CHIEF_EDITOR"
                    onClick={this.handleClick.bind(this)}
                    className="role-border"
                  >
                    {_("Editor-in-chief")}
                  </li>
                </ul>
              </li>
              <li className="block-role">
                <h5>{_("Organization roles")}</h5>
                <ul>
                  <li
                    id="1LEGAL_REPRESENTATIVE"
                    onClick={this.handleClick.bind(this)}
                  >
                    {_("Legal Reprentative")}
                  </li>
                  <li id="1MANAGER" onClick={this.handleClick.bind(this)}>
                    {_("Manager")}
                  </li>
                  <li
                    id="1OFFICIAL"
                    onClick={this.handleClick.bind(this)}
                    className="role-border"
                  >
                    {_("Official")}
                  </li>
                  <li
                    id="1EXTERNAL"
                    onClick={this.handleClick.bind(this)}
                    className="role-border"
                  >
                    {_("External")}
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  auth: state.auth
});

const mapDispatchToProps = dispatch => ({
  dispatch
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FilterBar);



// WEBPACK FOOTER //
// ./src/components/Settings/FilterBar.js